<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('companies.locations') }}</h3>
      <div class="header-meta">
        <Link :to="`/company/locations/new`" class="button button-green button-round button-small">{{
          $t('companies.addLocation')
        }}</Link>
      </div>
    </header>
    <div class="content-body">
      <LoadingSpinner v-if="loading" />
      <div v-if="!loading && locations.length == 0" class="alert alert-danger">
        {{ $t('companies.noDumpingStations') }}
      </div>
      <div v-else>
        <Table>
          <template #header>
            <th>{{ $t('meta.name') }}</th>
            <th>{{ $t('meta.address') }}</th>
            <th>{{ $t('meta.project') }}</th>
            <th></th>
          </template>
          <template #body>
            <tr v-for="{ uuid, name, preformatted, projects } in locations" :key="uuid">
              <td>{{ name }}</td>
              <td>{{ preformatted }}</td>
              <td>{{ $tc('pluralize.project', projects.length) }}</td>
              <td class="table__actions">
                <Link :to="`/company/locations/${uuid}`" class="table__action-button"
                  ><span class="material-icons">edit</span></Link
                >
                <button @click="deleteLocation(uuid)" class="table__action-button">
                  <span class="material-icons">delete</span>
                </button>
              </td>
            </tr>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import Table from '@/components/Table/index.vue'

import locationsApi from '@/api/locations'

export default {
  name: 'company_locations',
  inject: ['showPopup'],
  components: {
    LoadingSpinner,
    Table,
  },
  props: {
    companyUuid: { type: String, required: true },
  },
  data: () => ({
    loading: true,
    locations: [],
  }),
  methods: {
    async deleteLocation(locationUuid) {
      const confirmAlert = await this.showPopup({
        content: this.$t('companies.deleteLocationConfirmation'),
        type: 'confirm',
      })
      if (!confirmAlert) return null

      const response = await locationsApi.delete(locationUuid)
      if (response) {
        this.locations = await locationsApi.getAllForCompany(this.companyUuid)
      }
    },
  },
  async created() {
    this.locations = await locationsApi.getAllForCompany(this.companyUuid)
    this.loading = false
  },
}
</script>
